export default "__VITE_ASSET__Ce3nf3Tj__"